export default "https://statics.cloudfastin.top/static/v1.27.38.2/store/images/success1.png?7cabddaffe2a4bebac4deedee86d382c";